export function compactCurrency(value) {
  return formatValue(
    value,
    (val, { minimumFractionDigits = 0, maximumFractionDigits = 0 }) =>
      new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits,
        maximumFractionDigits,
      }).format(val),
  );
}

export function compactNumber(value) {
  return formatValue(
    value,
    (val, { minimumFractionDigits = 0, maximumFractionDigits = 0 }) => {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits,
        maximumFractionDigits,
      }).format(val);
    },
  );
}

function formatValue(value, formatter) {
  let localVal = value;
  let suffix = '';
  const thresholds = [
    { value: 1_000_000_000_000, suffix: 'T' },
    { value: 1_000_000_000, suffix: 'B' },
    { value: 1_000_000, suffix: 'M' },
    { value: 1_000, suffix: 'K' },
  ];

  for (let threshold of thresholds) {
    if (value >= threshold.value) {
      localVal = value / threshold.value;
      suffix = threshold.suffix;
      break;
    }
  }

  let formatted = formatter(localVal, {
    minimumFractionDigits: 0,
    maximumFractionDigits: getFractionDigits(value),
  });

  return `${formatted}${suffix}`;
}

function getFractionDigits(value) {
  // eslint-disable-next-line no-magic-numbers
  return value > 1_000_000_000 ? 1 : 0;
}
